import { TranslateModule } from './../../translate/translate.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ErrNoDataComponent } from './err-no-data.component';
import { IonicModule } from '@ionic/angular';

@NgModule({
  declarations: [ErrNoDataComponent],
  imports: [
    CommonModule, IonicModule, TranslateModule
  ],
  exports: [ErrNoDataComponent]
})
export class ErrNoDataModule { }
